import styled from "@emotion/styled";

import { ellipsise, SkiliticsIcon, Tooltip } from "@skilitics/designer-ui-components";

import type { EffectBuildable } from "../../types";
import { SidebarDraggable } from "./SidebarDraggable";

type Props = {
  effectBuildable: EffectBuildable;
};

export const EffectDraggable = ({ effectBuildable }: Props) => {
  const { nodeId, spec, name } = effectBuildable;

  return (
    <SidebarDraggable conditionOrEffect="effect" typeId={name} nodeId={nodeId} title={spec?.title}>
      <SkiliticsIcon icon="effect-action" />
      <Tooltip title={spec?.title} placement="right">
        <Title>{spec?.title}</Title>
      </Tooltip>
    </SidebarDraggable>
  );
};

const Title = styled.span`
  ${ellipsise}
  text-transform: capitalize;
`;
